import Storage from '../Storage.js';

Storage.setConfig("changes", {
  section: "etc",
  config: {
    method: "changes/",
    title: "История изменений",
    objectName: "Изменение",
    preset: true,
    variable_fields: {
      parameter: "changes",
      translations: {
        mailing_state: "Статус",
        sender_name: "Отправитель",
        recipient_name: "Получатель",
        list: "Реестр",
        state: "Статус",
        delete: "УДАЛЕНО",
        sender_address_locality: "Откуда - населенный пункт",
        sender_address_street: "Откуда - улица",
        sender_address_other: "Откуда - дом, квартира ...",
        recipient_address_locality: "Куда - населенный пункт",
        recipient_address_street: "Куда - улица",
        recipient_address_other: "Куда - дом, квартира ..."
      }
    },
    search: {
      mailing_id: {
        title: "# отправления",
        type: "text"
      },
    }
  },
  properties: {
    id: {
      default: false,
      type: "text",
      title: "#",
      preset: true,
      width: "20px"
    },
    user: {
      default: "",
      type: "select",
      title: "Кто",
      objectPageKey: "users",
      preset: true,
      width: "auto"
    },
    create_time: {
      default: "",
      type: "text",
      title: "Когда",
      preset: true,
      width: "auto"
    },
    modification_type: {
      default: "",
      type: "text",
      title: "Тип",
      preset: true,
      width: "auto"
    },
    mailings: {
      default: [],
      type: "multi",
      //request: "mailings/",
      title: "Отправления",
      objectPageKey: "mailings",
      preset: true,
      width: "auto"
    }
  }
});



// WEBPACK FOOTER //
// ./src/config/changes.js